import { Provider } from '@angular/core';

import { ContentTranslateRepositoryImpl } from '@app/data/repositories/content-translator/content-translator.repository';
import { CONTENT_TRANSLATE_REPOSITORY } from '@app/domain/repositories/content-translate/content-translate.repository.contract';

export const contentRepositoryProvider: Provider = {
  provide: CONTENT_TRANSLATE_REPOSITORY,
  useClass: ContentTranslateRepositoryImpl
};
